import styled from 'styled-components'
import { FONT } from 'utils'

export const HeaderText = styled.p`
   ${FONT({ size: '36px', weight: '500' })}
`
